import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../component/Loader";
import { Tab } from "../../component/Tab";

import { Edit } from "./edit";
import { Users } from "./users";

import api from "../../../../services/api";
import { toast } from "react-hot-toast";

export default function View() {
  const [campaign, setCampaign] = useState();
  const [tab, setTab] = useState("EDIT");
  const { id } = useParams();

  const fetchCampaign = async () => {
    try {
      const { data, ok } = await api.get(`/githeo_campaign/${id}`);
      console.log("data", data);
      if (!ok) throw toast.error("Error fetching campaign");
      setCampaign(data);
    } catch (error) {
      console.error("Error fetching campaign:", error);
    }
  };

  useEffect(() => {
    fetchCampaign();
  }, [id]);

  if (!campaign) return <Loader />;

  return (
    <div className="space-y-6 py-6 px-8">
      <h1 className="text-2xl font-semibold">{campaign.name}</h1>
      <div className="px-4 bg-white shadow-topbar space-x-8 rounded">
        <Tab active={tab === "EDIT"} onClick={() => setTab("EDIT")}>
          Edit
        </Tab>
        <Tab active={tab === "USER"} onClick={() => setTab("USER")}>
          Users
        </Tab>
      </div>
      {tab === "EDIT" && <Edit value={campaign} campaignId={id} />}
      {tab === "USER" && <Users campaign={campaign} />}
    </div>
  );
}
